import config from '../../config';

export default class ApiIPA {
    /**
     * It returns a promisse to be handle by the user
     * @param {*} GBGID the gbg id of the product
     * @param {*} userId the user who is skanning the product
     * @returns a promisse that handles the response
     */
    static getServiceItem(GBGID, userId) {
        const url = `${config.getEnvironment().IPABaseURL}/api/service_items/${GBGID}?user_id=${encodeURIComponent(userId)}`;
        return fetch(url);
    }
}